module.exports = __webpack_public_path__ + "static/img/rrslogo.459069c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rrslogo.png
// module id = DPYg
// module chunks = 9